import Vue from 'vue';
import Vuex from 'vuex';
import { merge } from 'lodash';

// Default data for signup form.
const signupDefaultData = {
	user: {
		id: '',
		email: '',
		firstName: '',
		lastName: '',
		telephone: '',
		city: '',
		country: '',
		pictureFile: undefined,
	},
	business: {
		name: '',
		registrationNumber: '',
		address: '',
		postalCode: '',
		city: '',
		country: '',
		industry: '',
		verifyDocument: undefined,
	},
};

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		auth: null,
		ref: null,
		signup: signupDefaultData,
	},
	mutations: {
		setAuth: (state, auth) => {
			state.auth = auth;
		},
		removeAuth: (state) => {
			state.auth = null;
		},
		setRef: (state, ref) => {
			state.ref = ref;
		},
		setSignupUser: (state, user) => {
			state.signup.user = merge(state.signup.user, user);
		},
		setSignupBusiness: (state, business) => {
			state.signup.business = merge(state.signup.business, business);
		},
		clearSignup: (state) => {
			state.signup = merge({}, signupDefaultData);
		},
	},
});
